import * as types from '@/store/license/actionTypes';
import {
  CLEAR_DEFAULT_LICENSE,
  CLEAR_LICENSES,
  SET_DEFAULT_LICENSE,
  SET_LICENSES,
} from '@/store/license/mutationTypes';

export default {
  async [types.SET_LICENSES]({ commit }, licenses) {
    try {
      commit(SET_LICENSES, licenses);
    } catch (e) {
      console.error('Set license error:', e);
      commit(CLEAR_LICENSES);
      throw e;
    }
  },
  async [types.CLEAR_LICENSES]({ commit }) {
    commit(CLEAR_LICENSES);
  },
  async [types.SET_DEFAULT_LICENSE]({ commit }, license) {
    try {
      commit(SET_DEFAULT_LICENSE, license);
    } catch (e) {
      console.error('Set license error:', e);
      commit(CLEAR_DEFAULT_LICENSE);
      throw e;
    }
  },
  async [types.CLEAR_DEFAULT_LICENSE]({ commit }) {
    commit(CLEAR_DEFAULT_LICENSE);
  },
};
